import { render, staticRenderFns } from "./BotaoAssinar.vue?vue&type=template&id=bdfe6a82&scoped=true"
import script from "./BotaoAssinar.vue?vue&type=script&lang=js"
export * from "./BotaoAssinar.vue?vue&type=script&lang=js"
import style0 from "./BotaoAssinar.vue?vue&type=style&index=0&id=bdfe6a82&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfe6a82",
  null
  
)

export default component.exports